import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{staticStyle:{"background-color":"#011E4A"}},[_c(VMain,[_c('user-bar'),_c('router-view',{staticClass:"view"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }